import * as React from 'react';
import { Prompt } from 'react-router';
import { Row, Col, Tabs, Badge } from 'antd';

import { ContextService } from 'src/core/services/context.service';
import { HeaderView } from 'src/app/shared/header.view';
import { ZuluIcon } from 'src/app/shared/icon';
import GeneralController from './parts/general.controller';
import GroupEntriesController from './parts/entries.controller';
import GroupPaxsController from './parts/paxs.controller';
import { DocumentGenerationController } from 'src/app/general/document-generation/document-generation.controller';

const TabPane = Tabs.TabPane;

interface IQuoteItineraryGroupFormViewProps extends ComponentViewProps<QuoteItineraryGroupSummary> {
	model: QuoteItineraryGroupSummary;
	title: string;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	save: () => Promise<void>;
	cancel: () => Promise<boolean>;

	itinerary: TourItineraryItem;

	contextService: ContextService;
	defaultLanguage: string;
}

interface IQuoteItineraryGroupFormViewState {
	reservationCount: number;
	paxCount: number;
}

export default class QuoteItineraryGroupFormView extends React.Component<IQuoteItineraryGroupFormViewProps, IQuoteItineraryGroupFormViewState>{

	constructor(props: any) {
		super(props);
		this.state = {
			reservationCount: 0,
			paxCount: 0
		}
	}

	render() {
		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row gutter={24}>
					<Col xs={24}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									hideModifyButtons={true}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<div className="card p-3">
									<Tabs defaultActiveKey={"General information"}>
										<TabPane tab={<span><ZuluIcon type="book" />General information</span>} key="General information" forceRender={true}>
											<GeneralController
												mode={this.props.mode}
												model={this.props.model}
												contextService={this.props.contextService}
												setBusy={this.props.setBusy}
												itinerary={this.props.itinerary}
												defaultLanguage={this.props.defaultLanguage}
											/>
										</TabPane>
										<TabPane tab={<Badge style={{ right: '-15px', marginTop: '5px' }} count={this.state.paxCount}><span><ZuluIcon type="team" /> Paxs</span></Badge>} key="Paxs" forceRender={true}>
											<GroupPaxsController
												groupId={this.props.model.id}
												contextService={this.props.contextService}
												setBusy={this.props.setBusy}
												onLoadData={(c) => this.setState({ paxCount: c })}
											/>
										</TabPane>
										<TabPane tab={<Badge style={{ right: '-15px', marginTop: '5px' }} count={this.state.reservationCount}><span><ZuluIcon type="shoping" /> Reservations</span></Badge>} key="Reservations" forceRender={true}>
											<GroupEntriesController
												groupId={this.props.model.id}
												contextService={this.props.contextService}
												setBusy={this.props.setBusy}
												onDataLoad={(c) => this.setState({ reservationCount: c })}
											/>
										</TabPane>

										<TabPane tab={<span><ZuluIcon type="file" />Documents</span>} key="Documents" forceRender={true}>
											<DocumentGenerationController
												mode={'edit'}
												contextService={this.props.contextService}
												usage="TourGroups"
												generationEnabled={true}
												containerId={this.props.model.documentsLibraryId}
												targetId={this.props.model.id}
												setBusy={this.props.setBusy}
											/>
										</TabPane>
									</Tabs>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>

			);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/quote-group-form.view.tsx